import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${themeGet('colors.background.50')};

  ${(props) => `
    width: ${pxToRem(props.$width)};
    height: ${pxToRem(props.$height)};
  `}
`;
